import { z } from 'zod';

export const ProdutoCestSchema = z.object({
    descricao: z.string(),
    prc_codigo: z.string(),
    prc_descricao_cest: z.string(),
    prc_ncm: z.string(),
});

export type ProdutoCest = z.infer<typeof ProdutoCestSchema>;
